angular.module('admin.reindexing', [
    'admin.reindexing.index',
  ]);


// WEBPACK FOOTER //
// ./client/src/app/admin/reindexing/index.js